import FormGroup from "legacy/FormGroup"
import PricingStructureSelect from "legacy/PricingStructureSelect"
import {
  centsToDollarsRaw,
  dollarsToCents,
  safePercentageDecimal,
  snakeCaseToReadable,
} from "legacy/helpers.es6.jsx"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class RateForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pricingStructure:
        Object.values(this.props.pricingStructures || {}).flat()[0]?.value ||
        "",
      billingCycle: this.props.billingCycles[0],
      amount: "",
      taxRate: 0,
      name: "",
      active: true,
      monthToMonth: false,
    }
    this.validator = validatorFactory()
  }

  componentDidMount() {
    if (
      this.props.selectedRate &&
      Object.keys(this.props.selectedRate).length > 0
    ) {
      this.useRate(this.props.selectedRate)
    }
  }

  useRate(rate) {
    this.setState({
      id: rate.id,
      pricingStructure: rate.pricing_structure,
      billingCycle: rate.billing_cycle,
      amount: centsToDollarsRaw(rate.amount),
      taxRate: safePercentageDecimal(rate.tax_rate),
      name: rate.name,
      active: rate.active,
      monthToMonth: rate.month_to_month,
    })
  }

  serialize() {
    return {
      pricing_structure: this.state.pricingStructure,
      billing_cycle: this.state.billingCycle,
      amount: Math.round(dollarsToCents(this.state.amount)),
      tax_rate: parseFloat(this.state.taxRate) / 100,
      name: this.state.name,
      active: this.state.active,
    }
  }

  markInactive() {
    this.setState(
      {
        active: false,
      },
      () => {
        this.props.saveRate()
      }
    )
  }

  renderWarning() {
    if (this.state.id) {
      return (
        <div className="alert alert-warning mt-3">
          Updates to an existing rate will not change any reservations currently
          using it.
          <br />
          <button
            type="button"
            className="btn btn-danger mt-3"
            onClick={() => {
              this.markInactive()
            }}
          >
            Remove Rate?
          </button>
        </div>
      )
    }
  }

  renderError() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-warning mt-3">
          {this.props.errorMessage}
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div className="row form-row">
          <div className="col-sm-6">
            <FormGroup
              label="Name"
              name="name"
              value={this.state.name}
              onChange={(e) => this.setState({ name: e.target.value })}
              validation={this.validator.message(
                "name",
                this.state.name,
                "required"
              )}
            />
          </div>
        </div>
        <div className="row form-row">
          <div className="col-sm-6">
            <FormGroup
              inputType="currency"
              label="Amount"
              name="amount"
              value={this.state.amount}
              onChange={(e) => this.setState({ amount: e.target.value })}
              validation={this.validator.message(
                "amount",
                this.state.amount,
                "min:0,num|required"
              )}
            />
          </div>
          <div className="col-sm-6">
            <FormGroup
              inputType="percentage"
              label="Tax Rate"
              name="taxRate"
              value={this.state.taxRate}
              onChange={(e) => this.setState({ taxRate: e.target.value })}
              validation={this.validator.message(
                "tax rate",
                this.state.taxRate,
                "min:0,num|required"
              )}
            />
          </div>
        </div>
        <div className="row form-row">
          <div className="col-sm-6">
            <PricingStructureSelect
              pricingStructure={this.state.pricingStructure}
              pricingStructures={this.props.pricingStructures}
              handleInputChange={(e) =>
                this.setState({ pricingStructure: e.target.value })
              }
            />
          </div>
          <div className="col-sm-6">
            <FormGroup
              inputType="select"
              label="Billing Cycle"
              name="billingCycle"
              value={this.state.billingCycle}
              onChange={(e) => this.setState({ billingCycle: e.target.value })}
              labelIcon={
                this.props.mbmTransientEnabled
                  ? "fa-kit fa-md-info cursor-pointer ml-2 -mt-1 font-semibold"
                  : ""
              }
              labelIconTooltip={
                "You can now customize the default billing schedule in Settings -> Reservations"
              }
              disabled={this.props.mbmTransientEnabled}
            >
              {this.props.mbmTransientEnabled ? (
                <option key="" value="" />
              ) : (
                (this.props.billingCycles || []).map((billing) => (
                  <option key={billing} value={billing}>
                    {snakeCaseToReadable(billing)}
                  </option>
                ))
              )}
            </FormGroup>
          </div>
        </div>
        {this.renderWarning()}
        {this.renderError()}
      </div>
    )
  }
}

RateForm.propTypes = {
  pricingStructures: PropTypes.object.isRequired,
  billingCycles: PropTypes.array.isRequired,
  selectedRate: PropTypes.object,
  errorMessage: PropTypes.string,
  saveRate: PropTypes.func.isRequired,
  mbmTransientEnabled: PropTypes.bool,
}

export default RateForm
